import React from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

import CreateEventTabs from 'pages/CreateEvent/Steps/CreateEventTabs';
import { org_friendly_url, user_access_level } from 'Api/Api';
// , organization_user_access_level
//import { Redirect } from 'react-router-dom';
import { local_routes } from 'utils/Routes';

import PublishButton from 'components/PublishButton/PublishButton';
import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';
import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton';
import ZoomControlModalButton from 'components/Modals/ZoomControlModalButton';
import StartZoomWebinarModalButton from 'components/Modals/StartZoomWebinarModalButton';

import home from 'Assets/home.svg';

import Footer from 'components/Footer/Footer';

class CreateEvent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            event_info: {},
            source_info: {}, // could be location or channel
            received_source_info: {}, // things like referrer
            //location_info: {},
            //locaName:null,
            //eventMode:null,
            
        };
        
        console.log("CreateEvent constructor props",props);

        if (props.location.data && props.location.data['source']) {
            this.state.received_source_info = props.location.data['source'];
        }
        
        this.Create_or_Edit = '';
        
        if (props.match && this.props.match.params && props.match.params.entity_uuid) {
            // edit
            this.Create_or_Edit = 'Manage';
        } else {
            this.Create_or_Edit = 'Create';
        }

        this.workspace_base_url = "";
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
    }

    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps);
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;

        this.routeChanged();
    }

    routeChanged () {
        console.log("CreateEvent routeChanged");
        this.forceUpdate();
        //this.APIPromises();
    }

    /*
    componentDidMount() {
        if (this.props.location.data) {
            // we know the location
            const { match: { params: { event_uuid } = {} } = {} } = this.props;
            let { match } = this.props;
        }
    }
    */

    eventDataMet = (event_info,source_info) => {
        console.log("CreateEvent eventDataMet",event_info,source_info);
        this.setState({
            event_info,
            source_info,
            loading: false
        });
    }
    
    /*
    locationDataMet=(recLocData,createStatus,eventName)=>{
        console.log("CreateEvent locationDataMet",recLocData,createStatus,eventName)
        this.setState({locaName:recLocData.entity_name})
        createStatus=== true ? this.setState({eventMode:"Create Event"}) : this.setState({eventMode:`Edit ${eventName} Event`});
    }
    */
    
    OnChangePublishOption = async (publish_obj, eventData, event_index) => {
        this.setState({
            event_info: {
                ...this.state.event_info,
                public_status: publish_obj.public_status
            }
        });
    }
    
    onWebinarIdChange = (zoom_webinar_id) => {
        this.setState({
            event_info: {
                ...this.state.event_info,
                zoom_webinar_id
            }
        });
    }
    

    render() {
        //const {locaName,eventMode } = this.state;
        
        //let received_source_info = {};
        //if (this.props.location.data && this.props.location.data.source) {
        //    received_source_info = this.props.location.data.source;
        //}
        
        let header_text = this.Create_or_Edit+" Event: "+this.state.event_info.entity_name;
        
        if (this.state.event_info.entity_name) {
            // edit or done loading
            header_text = this.Create_or_Edit+" Event: "+this.state.event_info.entity_name;
        } else {
            // create
            header_text = this.Create_or_Edit+" Event";
        }
        
        /*
        if (this.state.source_info.entity_name) {
            if (this.state.event_info.entity_name) {
                // edit event
                //header_text = this.Create_or_Edit+" Event "+this.state.event_info.entity_name+" : "+this.state.source_info.entity_name;
                header_text = this.Create_or_Edit+" Event: "+this.state.event_info.entity_name;
            } else {
                // create event
                //header_text = this.Create_or_Edit+" Event : "+this.state.source_info.entity_name;
                header_text = this.Create_or_Edit+" Event";
            }
        } else {
            // source is required!
            //console.error("CreateEvent MISSING SOURCE");
            //return (
            //    <Redirect  
            //        to={`${this.workspace_base_url}/`}
            //    />
            //);
        }
        */
        
        /*
        let status_text = "";
        if (this.state.event_info.status_code === 1) {
            status_text = "Published";
        } else if (this.state.event_info.status_code === 4) {
            status_text = "Draft"
        }
        */
        /* <div className="container createEvent"> */
        
        return (
          <React.Fragment>
            <Container className="container createEvent">
                <Row style={{ paddingTop: "10px" }} className="pad-bot10">
                    <Col lg={12} className="pad0">
                       
                        <h1 className="eventHead">{header_text}</h1>
                        { (this.state.source_info.entity_name && this.state.source_info.entity_type) &&
                            <p style={{ fontSize: "smaller", paddingTop: "5px" }}>{this.state.source_info.entity_name}</p>
                        }
                        <Row noGutters style={{ marginTop: "5px", marginBottom: "20px" }}>
                            { this.state.event_info.entity_uuid ?
                                <React.Fragment>
                                <Col xs={2}>
                                    <PublishButton
                                        entity_info={{status_code:this.state.event_info.status_code,entity_uuid:this.state.event_info.entity_uuid,entity_type:'events',publishable:true}}
                                    />
                                </Col>
                                <Col xs={1}>
                                    <ShareAccessModalButton
                                        entity_info={{...this.state.event_info,entity_type:'events'}}
                                        //publish_dropdown_options={this.publish_dropdown_options}
                                        //publish_dropdown_option_index={this.publish_dropdown_option_index}
                                        OnChangePublishOption={this.OnChangePublishOption}
                                        //index={props.index}
                                    />
                                </Col>
                                <Col xs={1}>
                                    <DownloadAssetsButton
                                        entity_info={{...this.state.event_info,entity_type:'events'}}
                                    />
                                </Col>
                                { user_access_level === 'admin' &&
                                    <Col xs={2}>
                                        <ZoomControlModalButton
                                            entity_info={{...this.state.event_info,entity_type:'events'}}
                                            onWebinarIdChange={this.onWebinarIdChange}
                                        />
                                    </Col>
                                }
                                </React.Fragment>
                                :
                                <React.Fragment>
                                { (user_access_level === 'admin' && !this.state.loading) &&
                                    <Col xs={2}>
                                        <ZoomControlModalButton
                                            disabled={true}
                                            entity_info={{...this.state.event_info,entity_type:'events'}}
                                            onWebinarIdChange={this.onWebinarIdChange}
                                        />
                                    </Col>
                                }
                                </React.Fragment>
                            }

                            { (this.state.event_info.zoom_webinar_id && this.state.event_info.zoom_webinar_object && this.state.event_info.zoom_webinar_object.start_url) &&
                                <Col xs={2}>
                                        <StartZoomWebinarModalButton
                                            entity_info={{...this.state.event_info,entity_type:'events'}}
                                        />
                                      {/*
                                       <a
                                            rel='noopener noreferrer'
                                            href={this.state.event_info.zoom_webinar_object.start_url}
                                            target="_blank"
                                        >
                                            <Button
                                                size="sm"
                                                variant="pkprimary"
                                            >
                                                Start Zoom Webinar
                                            </Button>
                                        </a>
                                      */}
                                </Col>
                            }
                        </Row>
                    </Col>
                    <Col lg={12}>
                        {/* <CreateEventTabs locationDataMet={this.locationDataMet} resetToList={this.props.resetToList} {...this.props} /> */}
                        <CreateEventTabs
                            key={this.state.event_info.zoom_webinar_id || null}
                            eventDataMet={this.eventDataMet}
                            received_source_info={this.state.received_source_info}
                            received_props={this.props.match.params}
                        />
                    </Col>
                </Row>
            </Container>
                <Footer
                homeImg={home}
                homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
                breadcrumbSubPage="Manage Event"/>
          </React.Fragment>
        );
    }
}

export default CreateEvent;